import React from "react";
import { Paper, Typography, Grid, Switch, FormControlLabel, Divider } from "@mui/material";

const GSTSettings = ({ watch, setValue }: any) => {
  const values = watch();

  const handleToggle = (key: string) => {
    setValue(key, !watch(key));
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" mb={2}>GST Settings</Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={values.enableGST} onChange={() => handleToggle("enableGST")} />}
            label="Enable GST"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Switch checked={values.enableHSNSACCode} onChange={() => handleToggle("enableHSNSACCode")} />}
            label="Enable HSN/SAC Code"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default GSTSettings;